/* eslint-disabled */

export default class TriggerExtend {


  constructor (object?: any) {
  }

  postConstruct () {
  }
}
